import { network } from 'services/network';
import { useMutation } from 'react-query';

const mutationFn = (params) => {
    const url = `api/bo/downloadXerFile/${params.id}`;
    return network
        .get(url, {
            responseType: 'blob',
        })
        .then((response) => {
            const blob = new Blob([response.data]);
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = params.fileName;
            a.click();
        })
        .catch((error) => {
            throw error;
        });
};
export const useMutationDownLoadXerFile = () => {
    return useMutation<any, QueryError, DownLoadXerFile>({
        mutationKey: ['downLoadXerFile'],
        mutationFn: (params) => mutationFn(params),
    });
};

interface DownLoadXerFile {
    id: number;
}
